// extracted by mini-css-extract-plugin
export default {"summary":"styles_summary__qvuhU","summary-item":"styles_summary-item__20xyw","summary-item--none":"styles_summary-item--none__29xSW"};